import type { SystemMonospaceFile as FileType } from '#layers/data-model';
import { RStoreSchema } from '#imports';
import { createFileHooks } from '~/rstore/utils/collections/files';

export const SystemMonospaceFile = RStoreSchema.withItemType<FileType>().defineCollection({
	name: 'SystemMonospaceFile',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: [
			'id',
			'fileName',
			'fileSize',
			'mediaType',
		],
		endpoint: 'system/files',
	},
	hooks: createFileHooks('system'),
});
